import Vue from 'vue'
import Router from 'vue-router'
// import axios from 'axios'
// import nativeJs from '../nativeJS/index'
// import { Dialog } from 'vant'
// // eslint-disable-next-line camelcase
// const { app_gotoSecondaryWebView } = nativeJs

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'eye',
      component: resolve => require(['@/views/eyes'], resolve),
      meta: {
        isLogin: true
      }
    },
    {
      path: '/queryQuestion',
      name: 'queryQuestion',
      component: resolve => require(['@/views/queryQuestion'], resolve),
      meta: {
        keepAlive: true, //该字段表示该页面需要缓存
        scrollY:0
      },
    },
    {
      path: '/queryDetail',
      name: 'queryDetail',
      component: resolve => require(['@/views/queryQuestion/detail.vue'], resolve)

    },
    {
      path: '/setQuestion',
      name: 'setQuestion',
      component: resolve => require(['@/views/queryQuestion/setQuestion.vue'], resolve)

    },
    {
      path: '/problemHelp',
      name: 'problemHelp',
      component: resolve => require(['@/views/problemHelp'], resolve)

    }
    // {
    //   path: '/eye',
    //   name: 'eye',
    //   component: resolve => require(['@/views/eye'], resolve)
    // }
    // {
    //   path: '/studyRoom',
    //   name: 'study',
    //   component: resolve => require(['@/views/studyRoom'], resolve)
    // },
    // {
    //   path: '/teachMessage',
    //   name: 'teachmessage',
    //   component: resolve => require(['@/views/studyRoom/teachMessage'], resolve)
    // },
    // {
    //   path: '/reCord',
    //   name: 'record',
    //   component: resolve => require(['@/views/reCord'], resolve)
    // },
    // {
    //   path: '/reDetails',
    //   name: 'recorddetails',
    //   component: resolve => require(['@/views/reCord/reDetails'], resolve)
    // },
    // {
    //   path: '/default',
    //   name: 'default',
    //   component: resolve => require(['@/views/default'], resolve)
    // }
  ]
})

// router.beforeEach(async (to, from, next) => {
//   const arr = ['/']
//   // const padMachineId = this.$route.query.padMachineId
//   // const padMachineId = '7HS1106048DBO'
//   if (arr.includes(to.path)) {
//     console.log(location.href)
//     let padMachineId = location.href.split('padMachineId=')[1] ? location.href.split('padMachineId=')[1] : ''
//     padMachineId = padMachineId.split('&')[0]
//     // 'https://assistant-pad-test.eebbk.net/app/store/v1/getStateByType?type=9&padMachineId=' + padMachineId,
//     axios.get('https://assistant-pad-test.eebbk.net/app/store/v1/getStateByType?type=9&H5MachineId=' + padMachineId)
//       .then(res => {
//         console.log(res.data)
//         let h5url = JSON.parse(res.data.data)
//         console.log(h5url)
//         if (h5url.isShow === 0) { // 没安装
//           console.log('1')
//           // next('/default')
//           window.localStorage.setItem('h5Url', res.data.data)
//           next({name: 'default'})
//         } else if (h5url.isShow === 1) { // 已安装
//           next()
//         }
//       })
//       .catch(err => {
//         console.error(err)
//       })
//   } else {
//     next()
//   }
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js